import emailjs from '@emailjs/browser';
import React, { useRef, useState } from 'react';
export default function Contact1() {
    const form = useRef();
  const [sending,setSending]= useState(false);
  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true)
    emailjs.sendForm('service_a3s5fjd', 'template_iuzmzv3', form.current, '2iTxB88mm3o47Nyqq')
      .then((result) => {
          console.log(result.text);
          form.current.reset()
          setSending(false)
      }, (error) => {
          console.log(error.text);
          setSending(false)
      });
  };
  return (
    <div className="container contact" dir="rtl">
      <h3>تواصل معنا </h3>
      <form  ref={form} onSubmit={sendEmail}  className="contact-form">
        <label>
          <span>بريدك الالكتروني </span>
          <input type="email" name="email" required />
        </label>
        <label>
          <span>رسالتك </span>
          <textarea name="message" required></textarea>
        </label>
        <button>{sending?" جاري الارسال ...": " ارسال "  }</button>
      </form>
    </div>
  )
}